/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Assignment from "@material-ui/icons/Assignment";
import Business from "@material-ui/icons/Business";
import Category from "@material-ui/icons/Category";
import FormatListBulleted from "@material-ui/icons/FormatListBulleted";
import AccountBalance from "@material-ui/icons/AccountBalance";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Layers from "@material-ui/icons/Layers";
import PlaylistAddCheck from "@material-ui/icons/PlaylistAddCheck";
import SubdirectoryArrowRight from "@material-ui/icons/SubdirectoryArrowRight";
import Description from "@material-ui/icons/Description";
import Domain from "@material-ui/icons/Domain";
import SettingsIcon from "@material-ui/icons/Settings";
import moment from "moment";
import { FinanceBudgetService } from "_services/financebudget.service";

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
  },
  menuCard: {
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    backgroundColor: "#ffffff",
    overflow: "hidden"
  },
  menuList: {
    padding: "6px 0"
  },
  menuItem: {
    padding: "10px 14px",
    margin: "3px 8px",
    borderRadius: 6,
    transition: "all 0.15s ease",
    "&:hover": {
      backgroundColor: "#f1f5f9"
    }
  },
  menuItemSelected: {
    padding: "10px 14px",
    margin: "3px 8px",
    borderRadius: 6,
    backgroundColor: "#eff6ff !important",
    borderLeft: "4px solid #1e3a8a",
    "&:hover": {
      backgroundColor: "#dbeafe !important"
    }
  },
  menuIcon: {
    minWidth: 34,
    color: "#64748b"
  },
  menuIconSelected: {
    minWidth: 34,
    color: "#1e3a8a"
  },
  tableHeadCell: {
    backgroundColor: "#1e3a8a",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "13px"
  },
  filterBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    alignItems: "center",
    marginBottom: "16px"
  },
  filterItem: {
    minWidth: 160
  }
}));

const MENU_ITEMS = [
  { label: "โครงการ", title: "จัดการข้อมูลโครงการ (Projects)", icon: Assignment },
  { label: "บริษัท / คู่ค้า ", title: "จัดการข้อมูลบริษัท / คู่ค้า (Companies)", icon: Business },
  { label: "หมวดจัดซื้อ", title: "จัดการข้อมูลหมวดจัดซื้อ (Categories)", icon: Category },
  { label: "หมวดย่อย", title: "จัดการข้อมูลหมวดย่อย (Sub Categories)", icon: FormatListBulleted },
  { label: "ประเภทงบประมาณ", title: "จัดการข้อมูลประเภทงบประมาณ (Budget Types)", icon: AccountBalance },
  { label: "ข้อมูลงบประมาณ", title: "จัดการข้อมูลงบประมาณ (Budgets)", icon: MonetizationOn },
  { label: "แหล่งของเงิน", title: "จัดการข้อมูลแหล่งของเงิน (Source Money)", icon: AttachMoney },
  { label: "ผลผลิต", title: "จัดการข้อมูลผลผลิต (Outputs)", icon: Layers },
  { label: "กิจกรรมหลัก", title: "จัดการข้อมูลกิจกรรมหลัก (Activities)", icon: PlaylistAddCheck },
  { label: "กิจกรรมย่อย", title: "จัดการข้อมูลกิจกรรมย่อย (Sub Activities)", icon: SubdirectoryArrowRight },
  { label: "ตามบันทึก", title: "จัดการข้อมูลตามบันทึก (Notes)", icon: Description },
  { label: "หน่วยงานที่ขอ", title: "จัดการข้อมูลหน่วยงานที่ขอ (Departments)", icon: Domain }
];

const getCurrentFiscalYear = () => {
  const now = moment();
  return (now.month() >= 9 ? now.year() + 543 + 1 : now.year() + 543).toString();
};

const SUBTAB_MAP = {
  project: 0,
  company: 1,
  category: 2,
  subcategory: 3,
  budgettype: 4,
  "budget-info": 5,
  budget: 5,
  sourcemoney: 6,
  output: 7,
  activity: 8,
  subactivity: 9,
  note: 10,
  department: 11,
  protectdep: 11
};

export default function MasterDataManager({ activeSubTab }) {
  const classes = useStyles();

  const getInitialTab = () => {
    if (activeSubTab && SUBTAB_MAP[activeSubTab.toLowerCase()] !== undefined) {
      return SUBTAB_MAP[activeSubTab.toLowerCase()];
    }
    return 0;
  };

  // Tab Index:
  // 0: โครงการ (Projects)
  // 1: บริษัท / คู่ค้า (Companies)
  // 2: หมวดจัดซื้อ (Categories)
  // 3: หมวดย่อย (SubCategories)
  // 4: ประเภทงบประมาณ (BudgetTypes)
  // 5: ข้อมูลงบประมาณ (Budgets)
  // 6: แหล่งของเงิน (SourceMoneys)
  // 7: ผลผลิต (Outputs)
  // 8: กิจกรรมหลัก (Activities)
  // 9: กิจกรรมย่อย (SubActivities)
  // 10: ตามบันทึก (Notes)
  // 11: หน่วยงานที่ขอ (ProtectDeps)
  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [loading, setLoading] = useState(false);

  // Sync activeTab when activeSubTab prop changes from sidebar navigation
  useEffect(() => {
    if (activeSubTab && SUBTAB_MAP[activeSubTab.toLowerCase()] !== undefined) {
      setActiveTab(SUBTAB_MAP[activeSubTab.toLowerCase()]);
    }
  }, [activeSubTab]);

  // Common Dropdown Masters
  const [years, setYears] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allNotes, setAllNotes] = useState([]);

  // Cascading options for filters / dialogs
  const [filterYear, setFilterYear] = useState(() => getCurrentFiscalYear());
  const [filterBtid, setFilterBtid] = useState("");
  const [filterBudget, setFilterBudget] = useState("");
  const [filterOid, setFilterOid] = useState("");
  const [filterCid, setFilterCid] = useState("");
  const [filterNote, setFilterNote] = useState("");

  const [optTypes, setOptTypes] = useState([]);
  const [optBudgets, setOptBudgets] = useState([]);
  const [optOutputs, setOptOutputs] = useState([]);

  // Lists
  const [projects, setProjects] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companySearch, setCompanySearch] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [budgetTypes, setBudgetTypes] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [sourceMoneys, setSourceMoneys] = useState([]);
  const [outputs, setOutputs] = useState([]);
  const [activities, setActivities] = useState([]);
  const [subActivities, setSubActivities] = useState([]);
  const [notes, setNotes] = useState([]);
  const [protectDeps, setProtectDeps] = useState([]);

  // Dialog State
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState(""); // "project", "company", "category", etc.
  const [formData, setFormData] = useState({});

  // Cascading for dialog internal dropdowns
  const [dialogTypes, setDialogTypes] = useState([]);
  const [dialogBudgets, setDialogBudgets] = useState([]);
  const [dialogOutputs, setDialogOutputs] = useState([]);
  const [dialogActivities, setDialogActivities] = useState([]);

  // Load Years & Base Masters on Mount
  useEffect(() => {
    FinanceBudgetService.getYears().then(res => {
      if (res.data.success) {
        setYears(res.data.data);
        if (res.data.data.length > 0 && !filterYear) {
          setFilterYear(res.data.data[0].value);
        }
      }
    });
    FinanceBudgetService.getCategories().then(res => {
      if (res.data.success) setAllCategories(res.data.data);
    });
    FinanceBudgetService.getNotes().then(res => {
      if (res.data.success) setAllNotes(res.data.data);
    });
  }, []);

  // Update cascading filter dropdowns when filterYear changes
  useEffect(() => {
    if (filterYear) {
      FinanceBudgetService.getBudgetTypes(filterYear).then(res => {
        if (res.data.success) setOptTypes(res.data.data);
      });
    } else {
      setOptTypes([]);
    }
    setFilterBtid("");
    setFilterBudget("");
    setFilterOid("");
    setOptBudgets([]);
    setOptOutputs([]);
  }, [filterYear]);

  // When filterBtid changes
  useEffect(() => {
    if (filterYear && filterBtid) {
      FinanceBudgetService.getBudgets(filterYear, parseInt(filterBtid)).then(res => {
        if (res.data.success) setOptBudgets(res.data.data);
      });
    } else {
      setOptBudgets([]);
    }
    setFilterBudget("");
    setFilterOid("");
    setOptOutputs([]);
  }, [filterBtid, filterYear]);

  // When filterBudget changes
  useEffect(() => {
    if (filterYear && filterBtid && filterBudget) {
      FinanceBudgetService.getOutputs(filterYear, parseInt(filterBtid), parseInt(filterBudget)).then(res => {
        if (res.data.success) setOptOutputs(res.data.data);
      });
    } else {
      setOptOutputs([]);
    }
    setFilterOid("");
  }, [filterBudget, filterBtid, filterYear]);

  // Fetch current tab data
  useEffect(() => {
    loadTabData();
  }, [activeTab, filterYear, filterBtid, filterBudget, filterOid, filterCid, filterNote]);

  const loadTabData = async () => {
    setLoading(true);
    try {
      switch (activeTab) {
        case 0: { // โครงการ
          const res = await FinanceBudgetService.getAllProjects(filterYear);
          if (res.data.success) setProjects(res.data.data);
          break;
        }
        case 1: { // บริษัท / คู่ค้า
          const res = await FinanceBudgetService.getAllCompanies(companySearch);
          if (res.data.success) setCompanies(res.data.data);
          break;
        }
        case 2: { // หมวดจัดซื้อ
          const res = await FinanceBudgetService.getAllCategories();
          if (res.data.success) setCategories(res.data.data);
          break;
        }
        case 3: { // หมวดย่อย
          const res = await FinanceBudgetService.getAllSubCategories(filterCid ? parseInt(filterCid) : null);
          if (res.data.success) setSubCategories(res.data.data);
          break;
        }
        case 4: { // ประเภทงบประมาณ
          const res = await FinanceBudgetService.getAllBudgetTypes(filterYear || null);
          if (res.data.success) setBudgetTypes(res.data.data);
          break;
        }
        case 5: { // ข้อมูลงบประมาณ
          const res = await FinanceBudgetService.getAllBudgets(
            filterYear || null,
            filterBtid ? parseInt(filterBtid) : null
          );
          if (res.data.success) setBudgets(res.data.data);
          break;
        }
        case 6: { // แหล่งของเงิน
          const res = await FinanceBudgetService.getAllSourceMoneys(filterBtid ? parseInt(filterBtid) : null);
          if (res.data.success) setSourceMoneys(res.data.data);
          break;
        }
        case 7: { // ผลผลิต
          const res = await FinanceBudgetService.getAllOutputs(
            filterYear || null,
            filterBtid ? parseInt(filterBtid) : null,
            filterBudget ? parseInt(filterBudget) : null
          );
          if (res.data.success) setOutputs(res.data.data);
          break;
        }
        case 8: { // กิจกรรมหลัก
          const res = await FinanceBudgetService.getAllActivities(
            filterYear || null,
            filterBtid ? parseInt(filterBtid) : null,
            filterBudget ? parseInt(filterBudget) : null,
            filterOid ? parseInt(filterOid) : null
          );
          if (res.data.success) setActivities(res.data.data);
          break;
        }
        case 9: { // กิจกรรมย่อย
          const res = await FinanceBudgetService.getAllSubActivities();
          if (res.data.success) setSubActivities(res.data.data);
          break;
        }
        case 10: { // ตามบันทึก
          const res = await FinanceBudgetService.getAllNotes();
          if (res.data.success) setNotes(res.data.data);
          break;
        }
        case 11: { // หน่วยงานที่ขอ
          const res = await FinanceBudgetService.getAllProtectDeps(filterNote ? parseInt(filterNote) : null);
          if (res.data.success) setProtectDeps(res.data.data);
          break;
        }
        default:
          break;
      }
    } catch (err) {
      console.error("Load master data error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Helper to open generic Dialog
  const handleOpenDialog = async (type, item = null) => {
    setDialogType(type);
    const yearVal = filterYear || getCurrentFiscalYear();

    if (type === "project") {
      const data = item || {
        pid: 0,
        calYear: yearVal,
        btid: filterBtid || "",
        budget: filterBudget || "",
        oid: filterOid || "",
        aid: "",
        pname: "",
        money: 0,
        remainMoney: 0
      };
      setFormData(data);
      if (data.calYear) {
        const tRes = await FinanceBudgetService.getBudgetTypes(data.calYear);
        if (tRes.data.success) setDialogTypes(tRes.data.data);
      }
      if (data.calYear && data.btid) {
        const bRes = await FinanceBudgetService.getBudgets(data.calYear, parseInt(data.btid));
        if (bRes.data.success) setDialogBudgets(bRes.data.data);
      }
      if (data.calYear && data.btid && data.budget) {
        const oRes = await FinanceBudgetService.getOutputs(data.calYear, parseInt(data.btid), parseInt(data.budget));
        if (oRes.data.success) setDialogOutputs(oRes.data.data);
        const aRes = await FinanceBudgetService.getActivities(data.calYear, parseInt(data.btid), parseInt(data.budget));
        if (aRes.data.success) setDialogActivities(aRes.data.data);
      }
    } else if (type === "company") {
      setFormData(item || { cid: 0, cname: "", address: "", tel: "" });
    } else if (type === "category") {
      setFormData(item || { cid: 0, catId: "", catName: "" });
    } else if (type === "subCategory") {
      setFormData(item || { sid: 0, cid: filterCid || "", catSubName: "", sid2: "" });
    } else if (type === "budgetType") {
      setFormData(item || { btid: 0, calYear: yearVal, btype: "", btid2: "", used: "1" });
    } else if (type === "budget") {
      const data = item || { bid: 0, calYear: yearVal, btid: filterBtid || "", bid2: "", bname: "" };
      setFormData(data);
      if (data.calYear) {
        const tRes = await FinanceBudgetService.getBudgetTypes(data.calYear);
        if (tRes.data.success) setDialogTypes(tRes.data.data);
      }
    } else if (type === "sourceMoney") {
      setFormData(item || { soid: 0, btid: filterBtid || "", sourceId: "", sourceName: "" });
    } else if (type === "output") {
      const data = item || { oid: 0, calYear: yearVal, btid: filterBtid || "", budget: filterBudget || "", oid2: "", oname: "" };
      setFormData(data);
      if (data.calYear) {
        const tRes = await FinanceBudgetService.getBudgetTypes(data.calYear);
        if (tRes.data.success) setDialogTypes(tRes.data.data);
      }
      if (data.calYear && data.btid) {
        const bRes = await FinanceBudgetService.getBudgets(data.calYear, parseInt(data.btid));
        if (bRes.data.success) setDialogBudgets(bRes.data.data);
      }
    } else if (type === "activity") {
      const data = item || { aid: 0, calYear: yearVal, btid: filterBtid || "", budget: filterBudget || "", oid: filterOid || "", aid2: "", aname: "", aid3: "1" };
      setFormData(data);
      if (data.calYear) {
        const tRes = await FinanceBudgetService.getBudgetTypes(data.calYear);
        if (tRes.data.success) setDialogTypes(tRes.data.data);
      }
      if (data.calYear && data.btid) {
        const bRes = await FinanceBudgetService.getBudgets(data.calYear, parseInt(data.btid));
        if (bRes.data.success) setDialogBudgets(bRes.data.data);
      }
      if (data.calYear && data.btid && data.budget) {
        const oRes = await FinanceBudgetService.getOutputs(data.calYear, parseInt(data.btid), parseInt(data.budget));
        if (oRes.data.success) setDialogOutputs(oRes.data.data);
      }
    } else if (type === "subActivity") {
      setFormData(item || { said: 0, calYear: "", saname: "", said2: "" });
    } else if (type === "note") {
      setFormData(item || { note: 0, noteName: "" });
    } else if (type === "protectDep") {
      setFormData(item || { protectDepId: 0, note: filterNote || "", protectDepName: "" });
    }

    setDialogOpen(true);
  };

  // Generic Save Handler
  const handleSave = async () => {
    try {
      switch (dialogType) {
        case "project": {
          if (!formData.pname) return alert("กรุณาระบุชื่อโครงการ");
          await FinanceBudgetService.saveProject({
            ...formData,
            btid: formData.btid ? parseInt(formData.btid) : null,
            budget: formData.budget ? parseInt(formData.budget) : null,
            oid: formData.oid ? parseInt(formData.oid) : null,
            aid: formData.aid ? parseInt(formData.aid) : null,
            money: parseFloat(formData.money || 0),
            remainMoney: parseFloat(formData.remainMoney || formData.money || 0)
          });
          break;
        }
        case "company": {
          if (!formData.cname) return alert("กรุณาระบุชื่อบริษัท/คู่ค้า");
          await FinanceBudgetService.saveCompany(formData);
          break;
        }
        case "category": {
          if (!formData.catName) return alert("กรุณาระบุชื่อหมวดจัดซื้อ");
          await FinanceBudgetService.saveCategory({
            ...formData,
            catId: formData.catId ? parseInt(formData.catId) : null
          });
          // Refresh global categories
          FinanceBudgetService.getCategories().then(res => {
            if (res.data.success) setAllCategories(res.data.data);
          });
          break;
        }
        case "subCategory": {
          if (!formData.catSubName) return alert("กรุณาระบุชื่อหมวดย่อย");
          await FinanceBudgetService.saveSubCategory({
            ...formData,
            cid: formData.cid ? parseInt(formData.cid) : null
          });
          break;
        }
        case "budgetType": {
          if (!formData.btype) return alert("กรุณาระบุชื่อประเภทงบประมาณ");
          await FinanceBudgetService.saveBudgetType(formData);
          break;
        }
        case "budget": {
          if (!formData.bname) return alert("กรุณาระบุชื่องบประมาณ");
          await FinanceBudgetService.saveBudget({
            ...formData,
            btid: formData.btid ? parseInt(formData.btid) : null
          });
          break;
        }
        case "sourceMoney": {
          if (!formData.sourceName) return alert("กรุณาระบุชื่อแหล่งของเงิน");
          await FinanceBudgetService.saveSourceMoney({
            ...formData,
            btid: formData.btid ? parseInt(formData.btid) : null
          });
          break;
        }
        case "output": {
          if (!formData.oname) return alert("กรุณาระบุชื่อผลผลิต");
          await FinanceBudgetService.saveOutput({
            ...formData,
            btid: formData.btid ? parseInt(formData.btid) : null,
            budget: formData.budget ? parseInt(formData.budget) : null
          });
          break;
        }
        case "activity": {
          if (!formData.aname) return alert("กรุณาระบุชื่อกิจกรรม");
          await FinanceBudgetService.saveActivity({
            ...formData,
            btid: formData.btid ? parseInt(formData.btid) : null,
            budget: formData.budget ? parseInt(formData.budget) : null,
            oid: formData.oid ? parseInt(formData.oid) : null
          });
          break;
        }
        case "subActivity": {
          if (!formData.saname) return alert("กรุณาระบุชื่อกิจกรรมย่อย");
          await FinanceBudgetService.saveSubActivity(formData);
          break;
        }
        case "note": {
          if (!formData.noteName) return alert("กรุณาระบุข้อความตามบันทึก");
          await FinanceBudgetService.saveNote(formData);
          // Refresh global notes
          FinanceBudgetService.getNotes().then(res => {
            if (res.data.success) setAllNotes(res.data.data);
          });
          break;
        }
        case "protectDep": {
          if (!formData.protectDepName) return alert("กรุณาระบุชื่อหน่วยงาน");
          await FinanceBudgetService.saveProtectDep({
            ...formData,
            note: formData.note ? parseInt(formData.note) : null
          });
          break;
        }
        default:
          break;
      }
      setDialogOpen(false);
      loadTabData();
    } catch (err) {
      alert("บันทึกไม่สำเร็จ: " + (err.response?.data?.message || err.message));
    }
  };

  // Generic Delete Handler
  const handleDelete = async (type, id) => {
    if (!window.confirm("ยืนยันการลบรายการนี้?")) return;
    try {
      switch (type) {
        case "project": await FinanceBudgetService.deleteProject(id); break;
        case "company": await FinanceBudgetService.deleteCompany(id); break;
        case "category": await FinanceBudgetService.deleteCategory(id); break;
        case "subCategory": await FinanceBudgetService.deleteSubCategory(id); break;
        case "budgetType": await FinanceBudgetService.deleteBudgetType(id); break;
        case "budget": await FinanceBudgetService.deleteBudget(id); break;
        case "sourceMoney": await FinanceBudgetService.deleteSourceMoney(id); break;
        case "output": await FinanceBudgetService.deleteOutput(id); break;
        case "activity": await FinanceBudgetService.deleteActivity(id); break;
        case "subActivity": await FinanceBudgetService.deleteSubActivity(id); break;
        case "note": await FinanceBudgetService.deleteNote(id); break;
        case "protectDep": await FinanceBudgetService.deleteProtectDep(id); break;
        default: break;
      }
      loadTabData();
    } catch (err) {
      alert("ลบไม่สำเร็จ: " + (err.response?.data?.message || err.message));
    }
  };

  const currentMenu = MENU_ITEMS[activeTab] || MENU_ITEMS[0];
  const CurrentIcon = currentMenu.icon;

  return (
    <div>
      <Card className={classes.card}>
        <CardContent style={{ padding: "20px 24px" }}>
          <Box mb={2} display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <CurrentIcon style={{ marginRight: 10, color: "#1e3a8a", fontSize: 26 }} />
              <Typography variant="h6" style={{ fontWeight: "bold", color: "#1e3a8a" }}>
                {currentMenu.title || currentMenu.label}
              </Typography>
            </Box>
            {loading && <CircularProgress size={22} style={{ color: "#1e3a8a" }} />}
          </Box>
          <Divider style={{ marginBottom: 20 }} />

              <Box>
          {/* ========================================================= */}
          {/* TAB 0: โครงการ (PROJECTS) */}
          {/* ========================================================= */}
          {activeTab === 0 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="ปีงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterYear}
                    onChange={e => setFilterYear(e.target.value)}
                    className={classes.filterItem}
                  >
                    {years.map(y => (
                      <MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("project")}
                >
                  + เพิ่มโครงการใหม่
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "10%" }}>ปีงบ</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อโครงการ</TableCell>
                    <TableCell className={classes.tableHeadCell} align="right" style={{ width: "16%" }}>งบจัดสรร (บาท)</TableCell>
                    <TableCell className={classes.tableHeadCell} align="right" style={{ width: "16%" }}>งบคงเหลือ (บาท)</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {projects.map(p => (
                    <TableRow key={p.pid} hover>
                      <TableCell align="center">{p.pid}</TableCell>
                      <TableCell>{p.calYear}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{p.pname}</TableCell>
                      <TableCell align="right">
                        {(p.money || 0).toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={{ color: (p.remainMoney || 0) < 0 ? "#dc2626" : "#16a34a", fontWeight: "bold" }}>
                        {(p.remainMoney || 0).toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("project", p)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("project", p.pid)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {projects.length === 0 && (
                    <TableRow><TableCell colSpan={6} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลโครงการ</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 1: บริษัท / คู่ค้า (COMPANIES) */}
          {/* ========================================================= */}
          {activeTab === 1 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    label="ค้นหาชื่อบริษัท / คู่ค้า"
                    size="small"
                    variant="outlined"
                    value={companySearch}
                    onChange={e => setCompanySearch(e.target.value)}
                    style={{ width: 260 }}
                  />
                  <Button variant="outlined" color="primary" onClick={loadTabData}>ค้นหา</Button>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("company")}
                >
                  + เพิ่มบริษัท/คู่ค้า
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อบริษัท/คู่ค้า</TableCell>
                    <TableCell className={classes.tableHeadCell}>ที่อยู่</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "16%" }}>เบอร์โทรศัพท์</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {companies.map(c => (
                    <TableRow key={c.cid} hover>
                      <TableCell align="center">{c.cid}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{c.cname}</TableCell>
                      <TableCell>{c.address || "-"}</TableCell>
                      <TableCell>{c.tel || "-"}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("company", c)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("company", c.cid)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {companies.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลบริษัท</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 2: หมวดจัดซื้อ (CATEGORIES) */}
          {/* ========================================================= */}
          {activeTab === 2 && (
            <div>
              <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("category")}
                >
                  + เพิ่มหมวดจัดซื้อ
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "10%" }}>รหัส (CID)</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "15%" }}>รหัสอ้างอิง (CatID)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อหมวดจัดซื้อ</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {categories.map(c => (
                    <TableRow key={c.cid} hover>
                      <TableCell align="center">{c.cid}</TableCell>
                      <TableCell align="center">{c.catId || "-"}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{c.catName}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("category", c)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("category", c.cid)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 3: หมวดย่อย (SUB CATEGORIES) */}
          {/* ========================================================= */}
          {activeTab === 3 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="กรองตามหมวดจัดซื้อ"
                    size="small"
                    variant="outlined"
                    value={filterCid}
                    onChange={e => setFilterCid(e.target.value)}
                    style={{ minWidth: 220 }}
                  >
                    <MenuItem value="">-- ทั้งหมด --</MenuItem>
                    {allCategories.map(c => (
                      <MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("subCategory")}
                >
                  + เพิ่มหมวดย่อย
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "20%" }}>หมวดจัดซื้อ</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "15%" }}>รหัสหมวดย่อย (Sid2)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อหมวดย่อย</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subCategories.map(s => {
                    const catObj = allCategories.find(c => c.value === (s.cid || "").toString());
                    return (
                      <TableRow key={s.sid} hover>
                        <TableCell align="center">{s.sid}</TableCell>
                        <TableCell>{catObj ? catObj.label : s.cid || "-"}</TableCell>
                        <TableCell>{s.sid2 || "-"}</TableCell>
                        <TableCell style={{ fontWeight: "500" }}>{s.catSubName}</TableCell>
                        <TableCell align="center">
                          <IconButton size="small" onClick={() => handleOpenDialog("subCategory", s)} color="primary">
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" onClick={() => handleDelete("subCategory", s.sid)} color="secondary">
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {subCategories.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลหมวดย่อย</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 4: ประเภทงบประมาณ (BUDGET TYPES) */}
          {/* ========================================================= */}
          {activeTab === 4 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="ปีงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterYear}
                    onChange={e => setFilterYear(e.target.value)}
                    className={classes.filterItem}
                  >
                    <MenuItem value="">-- ทั้งหมด --</MenuItem>
                    {years.map(y => (
                      <MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("budgetType")}
                >
                  + เพิ่มประเภทงบประมาณ
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "10%" }}>ปีงบ</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "15%" }}>รหัสประเภท (Btid2)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อประเภทงบประมาณ</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "10%" }}>ใช้งาน</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {budgetTypes.map(t => (
                    <TableRow key={t.btid} hover>
                      <TableCell align="center">{t.btid}</TableCell>
                      <TableCell>{t.calYear}</TableCell>
                      <TableCell>{t.btid2 || "-"}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{t.btype}</TableCell>
                      <TableCell align="center">{t.used === "1" ? "เปิดใช้งาน" : "ปิด"}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("budgetType", t)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("budgetType", t.btid)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {budgetTypes.length === 0 && (
                    <TableRow><TableCell colSpan={6} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลประเภทงบประมาณ</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 5: ข้อมูลงบประมาณ (BUDGETS) */}
          {/* ========================================================= */}
          {activeTab === 5 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="ปีงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterYear}
                    onChange={e => setFilterYear(e.target.value)}
                    className={classes.filterItem}
                  >
                    {years.map(y => (
                      <MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterBtid}
                    onChange={e => setFilterBtid(e.target.value)}
                    style={{ minWidth: 200 }}
                  >
                    <MenuItem value="">-- ทุกประเภท --</MenuItem>
                    {optTypes.map(t => (
                      <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("budget")}
                >
                  + เพิ่มข้อมูลงบประมาณ
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "8%" }}>ปีงบ</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "20%" }}>รหัสงบประมาณ (Bid2)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่องบประมาณ</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {budgets.map(b => (
                    <TableRow key={b.bid} hover>
                      <TableCell align="center">{b.bid}</TableCell>
                      <TableCell>{b.calYear}</TableCell>
                      <TableCell style={{ fontWeight: "bold", color: "#1e3a8a" }}>{b.bid2 || "-"}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{b.bname}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("budget", b)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("budget", b.bid)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {budgets.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลงบประมาณ</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 6: แหล่งของเงิน (SOURCE MONEY) */}
          {/* ========================================================= */}
          {activeTab === 6 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="ปีงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterYear}
                    onChange={e => setFilterYear(e.target.value)}
                    className={classes.filterItem}
                  >
                    {years.map(y => (
                      <MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterBtid}
                    onChange={e => setFilterBtid(e.target.value)}
                    style={{ minWidth: 200 }}
                  >
                    <MenuItem value="">-- ทุกประเภท --</MenuItem>
                    {optTypes.map(t => (
                      <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("sourceMoney")}
                >
                  + เพิ่มแหล่งของเงิน
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "20%" }}>ประเภทงบประมาณ</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "20%" }}>รหัสแหล่งเงิน (SourceId)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อแหล่งของเงิน</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sourceMoneys.map(s => {
                    const typeObj = optTypes.find(t => t.value === (s.btid || "").toString());
                    return (
                      <TableRow key={s.soid} hover>
                        <TableCell align="center">{s.soid}</TableCell>
                        <TableCell>{typeObj ? typeObj.label : s.btid || "-"}</TableCell>
                        <TableCell style={{ fontWeight: "bold", color: "#1e3a8a" }}>{s.sourceId || "-"}</TableCell>
                        <TableCell style={{ fontWeight: "500" }}>{s.sourceName}</TableCell>
                        <TableCell align="center">
                          <IconButton size="small" onClick={() => handleOpenDialog("sourceMoney", s)} color="primary">
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" onClick={() => handleDelete("sourceMoney", s.soid)} color="secondary">
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {sourceMoneys.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลแหล่งของเงิน</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 7: ผลผลิต (OUTPUTS) */}
          {/* ========================================================= */}
          {activeTab === 7 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="ปีงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterYear}
                    onChange={e => setFilterYear(e.target.value)}
                    className={classes.filterItem}
                  >
                    {years.map(y => (
                      <MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterBtid}
                    onChange={e => setFilterBtid(e.target.value)}
                    style={{ minWidth: 180 }}
                  >
                    <MenuItem value="">-- ทุกประเภท --</MenuItem>
                    {optTypes.map(t => (
                      <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="งบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterBudget}
                    onChange={e => setFilterBudget(e.target.value)}
                    style={{ minWidth: 220 }}
                  >
                    <MenuItem value="">-- ทุกงบประมาณ --</MenuItem>
                    {optBudgets.map(b => (
                      <MenuItem key={b.value} value={b.value}>{b.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("output")}
                >
                  + เพิ่มผลผลิต
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "8%" }}>ปีงบ</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "18%" }}>รหัสผลผลิต (Oid2)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อผลผลิต</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {outputs.map(o => (
                    <TableRow key={o.oid} hover>
                      <TableCell align="center">{o.oid}</TableCell>
                      <TableCell>{o.calYear}</TableCell>
                      <TableCell style={{ fontWeight: "bold", color: "#1e3a8a" }}>{o.oid2 || "-"}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{o.oname}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("output", o)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("output", o.oid)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {outputs.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลผลผลิต</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 8: กิจกรรมหลัก (ACTIVITIES) */}
          {/* ========================================================= */}
          {activeTab === 8 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="ปีงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterYear}
                    onChange={e => setFilterYear(e.target.value)}
                    className={classes.filterItem}
                  >
                    {years.map(y => (
                      <MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterBtid}
                    onChange={e => setFilterBtid(e.target.value)}
                    style={{ minWidth: 160 }}
                  >
                    <MenuItem value="">-- ทุกประเภท --</MenuItem>
                    {optTypes.map(t => (
                      <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="งบประมาณ"
                    size="small"
                    variant="outlined"
                    value={filterBudget}
                    onChange={e => setFilterBudget(e.target.value)}
                    style={{ minWidth: 200 }}
                  >
                    <MenuItem value="">-- ทุกงบประมาณ --</MenuItem>
                    {optBudgets.map(b => (
                      <MenuItem key={b.value} value={b.value}>{b.label}</MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    label="ผลผลิต"
                    size="small"
                    variant="outlined"
                    value={filterOid}
                    onChange={e => setFilterOid(e.target.value)}
                    style={{ minWidth: 200 }}
                  >
                    <MenuItem value="">-- ทุกผลผลิต --</MenuItem>
                    {optOutputs.map(o => (
                      <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("activity")}
                >
                  + เพิ่มกิจกรรมหลัก
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "8%" }}>ปีงบ</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "20%" }}>รหัสกิจกรรม (Aid2)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อกิจกรรม</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activities.map(a => (
                    <TableRow key={a.aid} hover>
                      <TableCell align="center">{a.aid}</TableCell>
                      <TableCell>{a.calYear}</TableCell>
                      <TableCell style={{ fontWeight: "bold", color: "#1e3a8a" }}>{a.aid2 || "-"}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{a.aname}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("activity", a)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("activity", a.aid)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {activities.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลกิจกรรม</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 9: กิจกรรมย่อย (SUB ACTIVITIES) */}
          {/* ========================================================= */}
          {activeTab === 9 && (
            <div>
              <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("subActivity")}
                >
                  + เพิ่มกิจกรรมย่อย
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "8%" }}>ลำดับ</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "18%" }}>รหัสกิจกรรมย่อย</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อกิจกรรมย่อย</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subActivities.map((sa, idx) => (
                    <TableRow key={sa.said || idx} hover>
                      <TableCell align="center">{idx + 1}</TableCell>
                      <TableCell style={{ fontWeight: "bold", color: "#1e3a8a" }}>{sa.said2 || "-"}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{sa.saname}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("subActivity", sa)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("subActivity", sa.said)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {subActivities.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลกิจกรรมย่อย</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 10: ตามบันทึก (NOTES) */}
          {/* ========================================================= */}
          {activeTab === 10 && (
            <div>
              <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("note")}
                >
                  + เพิ่มตามบันทึก
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "15%" }}>รหัส (Note)</TableCell>
                    <TableCell className={classes.tableHeadCell}>ข้อความตามบันทึก</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notes.map(n => (
                    <TableRow key={n.note} hover>
                      <TableCell align="center">{n.note}</TableCell>
                      <TableCell style={{ fontWeight: "500" }}>{n.noteName}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" onClick={() => handleOpenDialog("note", n)} color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete("note", n.note)} color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}

          {/* ========================================================= */}
          {/* TAB 11: หน่วยงานที่ขอ (PROTECT DEPS) */}
          {/* ========================================================= */}
          {activeTab === 11 && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <div className={classes.filterBox}>
                  <TextField
                    select
                    label="กรองตามบันทึก"
                    size="small"
                    variant="outlined"
                    value={filterNote}
                    onChange={e => setFilterNote(e.target.value)}
                    style={{ minWidth: 220 }}
                  >
                    <MenuItem value="">-- ทั้งหมด --</MenuItem>
                    {allNotes.map(n => (
                      <MenuItem key={n.value} value={n.value}>{n.label}</MenuItem>
                    ))}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog("protectDep")}
                >
                  + เพิ่มหน่วยงานที่ขอ
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "10%" }}>รหัส</TableCell>
                    <TableCell className={classes.tableHeadCell} style={{ width: "20%" }}>ตามบันทึก</TableCell>
                    <TableCell className={classes.tableHeadCell}>ชื่อหน่วยงานที่ขอ</TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "12%" }}>จัดการ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {protectDeps.map(d => {
                    const noteObj = allNotes.find(n => n.value === (d.note || "").toString());
                    return (
                      <TableRow key={d.protectDepId} hover>
                        <TableCell align="center">{d.protectDepId}</TableCell>
                        <TableCell>{noteObj ? noteObj.label : d.note || "-"}</TableCell>
                        <TableCell style={{ fontWeight: "500" }}>{d.protectDepName}</TableCell>
                        <TableCell align="center">
                          <IconButton size="small" onClick={() => handleOpenDialog("protectDep", d)} color="primary">
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" onClick={() => handleDelete("protectDep", d.protectDepId)} color="secondary">
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {protectDeps.length === 0 && (
                    <TableRow><TableCell colSpan={4} align="center" style={{ padding: 24, color: "#94a3b8" }}>ไม่พบข้อมูลหน่วยงาน</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
              </Box>
            </CardContent>
          </Card>

      {/* ========================================================= */}
      {/* GENERIC CRUD DIALOG */}
      {/* ========================================================= */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle style={{ backgroundColor: "#1e3a8a", color: "#fff" }}>
          {dialogType === "project" && (formData.pid ? "แก้ไขโครงการ" : "เพิ่มโครงการใหม่")}
          {dialogType === "company" && (formData.cid ? "แก้ไขบริษัท/คู่ค้า" : "เพิ่มบริษัท/คู่ค้าใหม่")}
          {dialogType === "category" && (formData.cid ? "แก้ไขหมวดจัดซื้อ" : "เพิ่มหมวดจัดซื้อใหม่")}
          {dialogType === "subCategory" && (formData.sid ? "แก้ไขหมวดย่อย" : "เพิ่มหมวดย่อยใหม่")}
          {dialogType === "budgetType" && (formData.btid ? "แก้ไขประเภทงบประมาณ" : "เพิ่มประเภทงบประมาณใหม่")}
          {dialogType === "budget" && (formData.bid ? "แก้ไขข้อมูลงบประมาณ" : "เพิ่มข้อมูลงบประมาณใหม่")}
          {dialogType === "sourceMoney" && (formData.soid ? "แก้ไขแหล่งของเงิน" : "เพิ่มแหล่งของเงินใหม่")}
          {dialogType === "output" && (formData.oid ? "แก้ไขผลผลิต" : "เพิ่มผลผลิตใหม่")}
          {dialogType === "activity" && (formData.aid ? "แก้ไขกิจกรรมหลัก" : "เพิ่มกิจกรรมหลักใหม่")}
          {dialogType === "subActivity" && (formData.said ? "แก้ไขกิจกรรมย่อย" : "เพิ่มกิจกรรมย่อยใหม่")}
          {dialogType === "note" && (formData.note ? "แก้ไขตามบันทึก" : "เพิ่มตามบันทึกใหม่")}
          {dialogType === "protectDep" && (formData.protectDepId ? "แก้ไขหน่วยงานที่ขอ" : "เพิ่มหน่วยงานที่ขอใหม่")}
        </DialogTitle>
        <DialogContent dividers style={{ padding: 24 }}>
          <Grid container spacing={2}>
            {/* 1. PROJECT FORM */}
            {dialogType === "project" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ปีงบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.calYear || ""}
                    onChange={async e => {
                      const yr = e.target.value;
                      setFormData({ ...formData, calYear: yr, btid: "", budget: "", oid: "", aid: "" });
                      const tRes = await FinanceBudgetService.getBudgetTypes(yr);
                      if (tRes.data.success) setDialogTypes(tRes.data.data);
                    }}
                  >
                    {years.map(y => (<MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={formData.btid || ""}
                    onChange={async e => {
                      const val = e.target.value;
                      setFormData({ ...formData, btid: val, budget: "", oid: "", aid: "" });
                      if (formData.calYear && val) {
                        const bRes = await FinanceBudgetService.getBudgets(formData.calYear, parseInt(val));
                        if (bRes.data.success) setDialogBudgets(bRes.data.data);
                      }
                    }}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogTypes.map(t => (<MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="งบประมาณ"
                    size="small"
                    variant="outlined"
                    value={formData.budget || ""}
                    onChange={async e => {
                      const val = e.target.value;
                      setFormData({ ...formData, budget: val, oid: "", aid: "" });
                      if (formData.calYear && formData.btid && val) {
                        const oRes = await FinanceBudgetService.getOutputs(formData.calYear, parseInt(formData.btid), parseInt(val));
                        if (oRes.data.success) setDialogOutputs(oRes.data.data);
                        const aRes = await FinanceBudgetService.getActivities(formData.calYear, parseInt(formData.btid), parseInt(val));
                        if (aRes.data.success) setDialogActivities(aRes.data.data);
                      }
                    }}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogBudgets.map(b => (<MenuItem key={b.value} value={b.value}>{b.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="กิจกรรมหลัก"
                    size="small"
                    variant="outlined"
                    value={formData.aid || ""}
                    onChange={e => setFormData({ ...formData, aid: e.target.value })}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogActivities.map(a => (<MenuItem key={a.value} value={a.value}>{a.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อโครงการ *"
                    size="small"
                    variant="outlined"
                    value={formData.pname || ""}
                    onChange={e => setFormData({ ...formData, pname: e.target.value })}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="number"
                    fullWidth
                    label="งบประมาณจัดสรร (บาท) *"
                    size="small"
                    variant="outlined"
                    value={formData.money ?? 0}
                    onChange={e => setFormData({ ...formData, money: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="number"
                    fullWidth
                    label="งบประมาณคงเหลือ (บาท) *"
                    size="small"
                    variant="outlined"
                    value={formData.remainMoney ?? 0}
                    onChange={e => setFormData({ ...formData, remainMoney: e.target.value })}
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 2. COMPANY FORM */}
            {dialogType === "company" && (
              <React.Fragment>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อบริษัท/คู่ค้า *"
                    size="small"
                    variant="outlined"
                    value={formData.cname || ""}
                    onChange={e => setFormData({ ...formData, cname: e.target.value })}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ที่อยู่"
                    size="small"
                    variant="outlined"
                    multiline
                    rows={2}
                    value={formData.address || ""}
                    onChange={e => setFormData({ ...formData, address: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="เบอร์โทรศัพท์"
                    size="small"
                    variant="outlined"
                    value={formData.tel || ""}
                    onChange={e => setFormData({ ...formData, tel: e.target.value })}
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 3. CATEGORY FORM */}
            {dialogType === "category" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="รหัสหมวด (CatID)"
                    size="small"
                    variant="outlined"
                    value={formData.catId || ""}
                    onChange={e => setFormData({ ...formData, catId: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อหมวดจัดซื้อ *"
                    size="small"
                    variant="outlined"
                    value={formData.catName || ""}
                    onChange={e => setFormData({ ...formData, catName: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 4. SUBCATEGORY FORM */}
            {dialogType === "subCategory" && (
              <React.Fragment>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="หมวดจัดซื้อ *"
                    size="small"
                    variant="outlined"
                    value={formData.cid || ""}
                    onChange={e => setFormData({ ...formData, cid: e.target.value })}
                  >
                    <MenuItem value="">-- เลือกหมวดจัดซื้อ --</MenuItem>
                    {allCategories.map(c => (<MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="รหัสหมวดย่อย (Sid2)"
                    size="small"
                    variant="outlined"
                    value={formData.sid2 || ""}
                    onChange={e => setFormData({ ...formData, sid2: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อหมวดย่อย *"
                    size="small"
                    variant="outlined"
                    value={formData.catSubName || ""}
                    onChange={e => setFormData({ ...formData, catSubName: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 5. BUDGET TYPE FORM */}
            {dialogType === "budgetType" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ปีงบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.calYear || ""}
                    onChange={e => setFormData({ ...formData, calYear: e.target.value })}
                  >
                    {years.map(y => (<MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="รหัสประเภท (Btid2)"
                    size="small"
                    variant="outlined"
                    value={formData.btid2 || ""}
                    onChange={e => setFormData({ ...formData, btid2: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อประเภทงบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.btype || ""}
                    onChange={e => setFormData({ ...formData, btype: e.target.value })}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="สถานะ"
                    size="small"
                    variant="outlined"
                    value={formData.used || "1"}
                    onChange={e => setFormData({ ...formData, used: e.target.value })}
                  >
                    <MenuItem value="1">เปิดใช้งาน</MenuItem>
                    <MenuItem value="0">ปิดการใช้งาน</MenuItem>
                  </TextField>
                </Grid>
              </React.Fragment>
            )}

            {/* 6. BUDGET FORM */}
            {dialogType === "budget" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ปีงบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.calYear || ""}
                    onChange={async e => {
                      const yr = e.target.value;
                      setFormData({ ...formData, calYear: yr, btid: "" });
                      const tRes = await FinanceBudgetService.getBudgetTypes(yr);
                      if (tRes.data.success) setDialogTypes(tRes.data.data);
                    }}
                  >
                    {years.map(y => (<MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={formData.btid || ""}
                    onChange={e => setFormData({ ...formData, btid: e.target.value })}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogTypes.map(t => (<MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="รหัสงบประมาณ (Bid2)"
                    size="small"
                    variant="outlined"
                    value={formData.bid2 || ""}
                    onChange={e => setFormData({ ...formData, bid2: e.target.value })}
                    placeholder="เช่น 21003340008003210007"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่องบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.bname || ""}
                    onChange={e => setFormData({ ...formData, bname: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 7. SOURCE MONEY FORM */}
            {dialogType === "sourceMoney" && (
              <React.Fragment>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="ประเภทงบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.btid || ""}
                    onChange={e => setFormData({ ...formData, btid: e.target.value })}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {optTypes.map(t => (<MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="รหัสแหล่งของเงิน (SourceId)"
                    size="small"
                    variant="outlined"
                    value={formData.sourceId || ""}
                    onChange={e => setFormData({ ...formData, sourceId: e.target.value })}
                    placeholder="เช่น 6326000"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อแหล่งของเงิน *"
                    size="small"
                    variant="outlined"
                    value={formData.sourceName || ""}
                    onChange={e => setFormData({ ...formData, sourceName: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 8. OUTPUT FORM */}
            {dialogType === "output" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ปีงบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.calYear || ""}
                    onChange={async e => {
                      const yr = e.target.value;
                      setFormData({ ...formData, calYear: yr, btid: "", budget: "" });
                      const tRes = await FinanceBudgetService.getBudgetTypes(yr);
                      if (tRes.data.success) setDialogTypes(tRes.data.data);
                    }}
                  >
                    {years.map(y => (<MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={formData.btid || ""}
                    onChange={async e => {
                      const val = e.target.value;
                      setFormData({ ...formData, btid: val, budget: "" });
                      if (formData.calYear && val) {
                        const bRes = await FinanceBudgetService.getBudgets(formData.calYear, parseInt(val));
                        if (bRes.data.success) setDialogBudgets(bRes.data.data);
                      }
                    }}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogTypes.map(t => (<MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="งบประมาณ"
                    size="small"
                    variant="outlined"
                    value={formData.budget || ""}
                    onChange={e => setFormData({ ...formData, budget: e.target.value })}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogBudgets.map(b => (<MenuItem key={b.value} value={b.value}>{b.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="รหัสผลผลิต (Oid2)"
                    size="small"
                    variant="outlined"
                    value={formData.oid2 || ""}
                    onChange={e => setFormData({ ...formData, oid2: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อผลผลิต *"
                    size="small"
                    variant="outlined"
                    value={formData.oname || ""}
                    onChange={e => setFormData({ ...formData, oname: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 9. ACTIVITY FORM */}
            {dialogType === "activity" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ปีงบประมาณ *"
                    size="small"
                    variant="outlined"
                    value={formData.calYear || ""}
                    onChange={async e => {
                      const yr = e.target.value;
                      setFormData({ ...formData, calYear: yr, btid: "", budget: "", oid: "" });
                      const tRes = await FinanceBudgetService.getBudgetTypes(yr);
                      if (tRes.data.success) setDialogTypes(tRes.data.data);
                    }}
                  >
                    {years.map(y => (<MenuItem key={y.value} value={y.value}>{y.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ประเภทงบประมาณ"
                    size="small"
                    variant="outlined"
                    value={formData.btid || ""}
                    onChange={async e => {
                      const val = e.target.value;
                      setFormData({ ...formData, btid: val, budget: "", oid: "" });
                      if (formData.calYear && val) {
                        const bRes = await FinanceBudgetService.getBudgets(formData.calYear, parseInt(val));
                        if (bRes.data.success) setDialogBudgets(bRes.data.data);
                      }
                    }}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogTypes.map(t => (<MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="งบประมาณ"
                    size="small"
                    variant="outlined"
                    value={formData.budget || ""}
                    onChange={async e => {
                      const val = e.target.value;
                      setFormData({ ...formData, budget: val, oid: "" });
                      if (formData.calYear && formData.btid && val) {
                        const oRes = await FinanceBudgetService.getOutputs(formData.calYear, parseInt(formData.btid), parseInt(val));
                        if (oRes.data.success) setDialogOutputs(oRes.data.data);
                      }
                    }}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogBudgets.map(b => (<MenuItem key={b.value} value={b.value}>{b.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="ผลผลิต"
                    size="small"
                    variant="outlined"
                    value={formData.oid || ""}
                    onChange={e => setFormData({ ...formData, oid: e.target.value })}
                  >
                    <MenuItem value="">-- ไม่ระบุ --</MenuItem>
                    {dialogOutputs.map(o => (<MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="รหัสกิจกรรม (Aid2)"
                    size="small"
                    variant="outlined"
                    value={formData.aid2 || ""}
                    onChange={e => setFormData({ ...formData, aid2: e.target.value })}
                    placeholder="เช่น 21003698192400000"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อกิจกรรมหลัก *"
                    size="small"
                    variant="outlined"
                    value={formData.aname || ""}
                    onChange={e => setFormData({ ...formData, aname: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 10. SUB ACTIVITY FORM */}
            {dialogType === "subActivity" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="รหัสกิจกรรมย่อย"
                    size="small"
                    variant="outlined"
                    value={formData.said2 || ""}
                    onChange={e => setFormData({ ...formData, said2: e.target.value })}
                    placeholder="เช่น 01 หรือ รหัสย่อย"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อกิจกรรมย่อย *"
                    size="small"
                    variant="outlined"
                    value={formData.saname || ""}
                    onChange={e => setFormData({ ...formData, saname: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 11. NOTE FORM */}
            {dialogType === "note" && (
              <React.Fragment>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="number"
                    fullWidth
                    label="รหัส (Note ID)"
                    size="small"
                    variant="outlined"
                    value={formData.note || ""}
                    onChange={e => setFormData({ ...formData, note: parseInt(e.target.value || 0) })}
                    disabled={Boolean(formData.note && formData.note > 0)}
                    helperText={formData.note ? "ไม่สามารถแก้ไขรหัสได้" : "เว้นว่างเพื่อให้ระบบกำหนดให้อัตโนมัติ"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ข้อความตามบันทึก *"
                    size="small"
                    variant="outlined"
                    value={formData.noteName || ""}
                    onChange={e => setFormData({ ...formData, noteName: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}

            {/* 11. PROTECT DEP FORM */}
            {dialogType === "protectDep" && (
              <React.Fragment>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="ตามบันทึก"
                    size="small"
                    variant="outlined"
                    value={formData.note || ""}
                    onChange={e => setFormData({ ...formData, note: e.target.value })}
                  >
                    <MenuItem value="">-- ทุกบันทึก / ทั่วไป --</MenuItem>
                    {allNotes.map(n => (<MenuItem key={n.value} value={n.value}>{n.label}</MenuItem>))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="ชื่อหน่วยงานที่ขอ *"
                    size="small"
                    variant="outlined"
                    value={formData.protectDepName || ""}
                    onChange={e => setFormData({ ...formData, protectDepName: e.target.value })}
                    required
                  />
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button onClick={() => setDialogOpen(false)} color="default">
            ยกเลิก
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
